import React from "react";
import i18n from "i18next";
import Modal from "../../../modal/ModalNotify.js";
// import { disconnectUser } from "../../../../utils/replaceUserSignIn.js";
// import Pricing from "../../component/pricing_table/pricingAccount";

// import axios from "axios";

function NoCreditProspect(props) {
  const { buttonRef, modalRef, show, showModal, hideModal, user, plan } = props;

  // function handleStripe(modification) {
  //   const token = localStorage.getItem("token");
  //   if (!token) {
  //     disconnectUser();
  //   }
  //   const config = {
  //     headers: { Authorization: `${token}` },
  //   };

  //   let data = {
  //     user: {
  //       stripe_id: user.stripe_id,
  //     },
  //     lng: localStorage.getItem("i18nextLng"),
  //     modification: modification,
  //   };

  //   axios
  //     .post(
  //       process.env.REACT_APP_URL_API + "/create-customer-portal-session",
  //       data,
  //       config
  //     )
  //     .then((response) => {
  //       window.location = response["data"].response;
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // }

  return (
    plan &&
    user && (
      <main>
        <Modal ref={modalRef} show={show} handleClose={hideModal}>
          <div className="flex flex-col gap-y-3.5 text-secondary pb-5 max-w-xl">
            <h1 className="">{i18n.t("modal.prospect.no_credit.title")}</h1>
            <p
              dangerouslySetInnerHTML={{
                __html: i18n.t(`modal.prospect.no_credit.description`, {
                  name: user.first_name,
                }),
              }}
            />
          </div>
          <div className="flex flex-col gap-y-3.5 text-secondary pb-5 max-w-xl">
            <h1 className="">{i18n.t("modal.prospect.no_credit.title2")}</h1>
            <p
              dangerouslySetInnerHTML={{
                __html: i18n.t(`modal.prospect.no_credit.description2`),
              }}
            />
          </div>

          <hr className="separator-product"></hr>
          <div className="flex flex-col gap-y-5 justify-start pt-5 ">
            <div
              ref={buttonRef}
              className="button-modal button-blue-modal rounded-custom-input cursor-pointer"
            >
              <p className="font-semibold	">
                {i18n.t("modal.prospect.no_credit.action1")}
              </p>
            </div>
            <a
              target="_blank"
              href="https://screebot.com/docs/comment-appliquer-un-code-promo/"
              className="flex flex-row gap-x-2.5 text-secondary w-fit p-0"
              rel="noreferrer"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.7092 6.96515C10.7092 6.0226 9.94247 5.25586 8.99991 5.25586C8.05736 5.25586 7.29062 6.0226 7.29062 6.96515C7.29062 7.23493 7.50921 7.45352 7.77899 7.45352C8.04876 7.45352 8.26736 7.23493 8.26736 6.96515C8.26736 6.56117 8.59593 6.2326 8.99991 6.2326C9.40389 6.2326 9.73247 6.56117 9.73247 6.96515C9.73247 7.22692 9.59768 7.4629 9.37205 7.59632C8.66079 8.0171 8.51154 8.50332 8.51154 8.83717V9.65119C8.51154 9.92096 8.73014 10.1396 8.99991 10.1396C9.26969 10.1396 9.48828 9.92096 9.48828 9.65119V8.83717C9.48828 8.7309 9.63792 8.57384 9.86941 8.43691C10.3875 8.1304 10.7092 7.56643 10.7092 6.96515Z"
                  fill="#486497"
                />
                <path
                  d="M9.10459 12.2471C9.45954 12.1894 9.70057 11.855 9.64295 11.5C9.58534 11.1451 9.25089 10.9041 8.89595 10.9617C8.541 11.0193 8.29997 11.3537 8.35759 11.7087C8.4152 12.0636 8.74965 12.3047 9.10459 12.2471Z"
                  fill="#486497"
                />
                <path
                  d="M15.5116 8.51153C15.2419 8.51153 15.0233 8.73013 15.0233 8.9999C15.0233 11.9309 15.0233 13.4021 14.2126 14.2126C13.4021 15.0231 11.9309 15.0231 8.9999 15.0231C6.0689 15.0231 4.59774 15.0231 3.78724 14.2124C2.97674 13.4019 2.97674 11.9307 2.97674 8.99971C2.97674 6.06871 2.97674 4.59754 3.78724 3.78704C4.59774 2.97654 6.0689 2.97654 8.9999 2.97654C11.9309 2.97654 13.4021 2.97654 14.2126 3.78704C14.7068 4.28127 14.9168 4.99468 14.9879 6.41936C15.0014 6.68874 15.2309 6.89659 15.4999 6.88272C15.7693 6.86924 15.9768 6.6401 15.9635 6.37071C15.8937 4.97202 15.6869 3.87983 14.9033 3.09629C14.3692 2.56221 13.6705 2.26196 12.6377 2.12326C11.7186 2 10.5783 2 8.9999 2C7.42149 2 6.28125 2 5.36233 2.12366C4.32952 2.26255 3.63076 2.5626 3.09649 3.09668C2.56221 3.63076 2.26235 4.32952 2.12366 5.36233C2 6.28144 2 7.42169 2 8.9999C2 10.5781 2 11.7186 2.12366 12.6375C2.26255 13.6703 2.5626 14.369 3.09668 14.9031C3.63076 15.4372 4.32952 15.7375 5.36252 15.8762C6.28144 15.9998 7.42188 15.9998 9.0001 15.9998C10.5783 15.9998 11.7188 15.9998 12.6377 15.8762C13.6705 15.7373 14.3692 15.4372 14.9033 14.9031C15.4374 14.369 15.7376 13.6703 15.8763 12.6375C16 11.7186 16 10.5781 16 8.9999C16 8.73013 15.7814 8.51153 15.5116 8.51153Z"
                  fill="#486497"
                />
              </svg>

              <p>{i18n.t("modal.prospect.no_credit.action2")}</p>
            </a>
          </div>
        </Modal>
        <button
          className="account-btn hidden"
          type="button"
          onClick={() => showModal}
        >
          <svg
            width="16"
            height="11"
            viewBox="0 0 16 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 0.166687C3.24357 0.166687 0.171194 5.07932 0.115625 5.16877C0.0408285 5.26299 8.08654e-05 5.37972 0 5.50002C9.4615e-05 5.60322 0.030128 5.70417 0.0864583 5.79065L0.0885417 5.79377C0.0977116 5.81269 2.67671 10.8334 8 10.8334C13.3007 10.8334 15.8759 5.86202 15.9073 5.80106C15.9094 5.79761 15.9115 5.79414 15.9135 5.79065C15.9699 5.70417 15.9999 5.60322 16 5.50002C16 5.3802 15.9596 5.26389 15.8854 5.16981L15.8844 5.16877C15.8288 5.07932 12.7564 0.166687 8 0.166687ZM8 1.76669C10.0619 1.76669 11.7333 3.43815 11.7333 5.50002C11.7333 7.56189 10.0619 9.23335 8 9.23335C5.93813 9.23335 4.26667 7.56189 4.26667 5.50002C4.26667 3.43815 5.93813 1.76669 8 1.76669ZM8 3.90002C7.57565 3.90002 7.16869 4.06859 6.86863 4.36865C6.56857 4.66871 6.4 5.07567 6.4 5.50002C6.4 5.92437 6.56857 6.33133 6.86863 6.63139C7.16869 6.93145 7.57565 7.10002 8 7.10002C8.42435 7.10002 8.83131 6.93145 9.13137 6.63139C9.43143 6.33133 9.6 5.92437 9.6 5.50002C9.6 5.07567 9.43143 4.66871 9.13137 4.36865C8.83131 4.06859 8.42435 3.90002 8 3.90002Z"
              fill="white"
            />
          </svg>
          <div>{i18n.t("sidebar.payment.subscription")}</div>
        </button>
      </main>
    )
  );
}

export default NoCreditProspect;
